import {Cell, flexRender} from "@tanstack/react-table";
import {default as classNames} from "classnames";
import {Fragment} from "react";

import {getPinnedCellProps, isClickHandledByRowContent} from "../TableMarkup/TableMarkup.utils.ts";
import {StaticRowProps} from "./StaticRow.types.ts";

import {default as tableStyles} from "../TableMarkup/TableMarkup.module.scss";

export const StaticRow = <TData,>({
  row,
  subrowRenderer,
  expandableSubRows,
  addEndSpacer,
  tableRowOnClick,
  tableRowClassName,
  rowRef,
  rowStyle,
}: StaticRowProps<TData>) => {
  return (
    <Fragment>
      <tr
        ref={rowRef}
        style={rowStyle}
        onClick={(event) => {
          if (isClickHandledByRowContent(event)) return;
          tableRowOnClick?.(row);
        }}
        className={classNames(tableRowClassName, tableStyles.tableRowDefault)}
      >
        {row.getVisibleCells().map((cell: Cell<TData, unknown>) => {
          const pinnedProps = getPinnedCellProps(cell.column);
          return (
            <td
              className={classNames(
                cell.column.columnDef.meta?.columnClassName,
                "align-middle p-2",
                pinnedProps.className,
                {"cursor-pointer": !!cell.column.columnDef.meta?.onClick}
              )}
              style={pinnedProps.style}
              role="presentation"
              key={cell.id}
              onClick={
                cell.column.columnDef.meta?.onClick
                  ? (event) => {
                      if (isClickHandledByRowContent(event)) return;
                      cell.column.columnDef.meta?.onClick?.(event, cell);
                    }
                  : undefined
              }
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </td>
          );
        })}
      </tr>
      {subrowRenderer && (!expandableSubRows || (expandableSubRows && row.getIsExpanded())) && (
        <tr className="sub-row">{subrowRenderer(row.original)}</tr>
      )}
      {addEndSpacer && (
        <tr>
          <td className={tableStyles.subRowEndSpacer} colSpan={row.getVisibleCells().length} />
        </tr>
      )}
    </Fragment>
  );
};
